import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { QUERY_PARAM_KEY, QUERY_PARAM_VALUE } from '_constants/queryParams';

const QUERY_PARAM_VALUE_ARRAY = [
  QUERY_PARAM_VALUE.personal,
  QUERY_PARAM_VALUE.dependents,
  QUERY_PARAM_VALUE.filingInfo,
];

export const useConfirmInfoQueryParam = () => {
  const [params, setParams] = useSearchParams();
  const currentParam = params.get(QUERY_PARAM_KEY.confirmInfoTab);

  const setCurrentParam = (value) => {
    params.delete(QUERY_PARAM_KEY.confirmInfoTab);
    params.append(QUERY_PARAM_KEY.confirmInfoTab, value);
    setParams(params);
  };

  useEffect(() => {
    if (!QUERY_PARAM_VALUE_ARRAY.includes(currentParam)) {
      params.delete(QUERY_PARAM_KEY.confirmInfoTab);
      params.append(QUERY_PARAM_KEY.confirmInfoTab, QUERY_PARAM_VALUE.personal);
      setParams(params);
    }
  }, [currentParam, params, setParams]);

  return [currentParam, setCurrentParam];
};
